module.exports = __webpack_public_path__ + "static/img/app01.761d900f.png";